
<template>
  <!--新增社区app菜单-->
  <x-addApplication></x-addApplication>
</template>

<script>
export default {
  name: 'addCommunityApp',
  data () {
    return {};
  },
  mounted () {},
  methods: {}
};
</script>
